import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer } from './AdminStyles';

interface ToastProps {
  message: string;
  show: boolean;
}

export function Toast({ message, show }: ToastProps) {
  return (
    <ToastContainer $show={show}>
      <FontAwesomeIcon icon={faCheckCircle} />
      {message}
    </ToastContainer>
  );
}
